export interface ISmsServer {
    enabled?: boolean;
    fromPhoneNumber?: string;
}

export class SmsServer implements ISmsServer {
    constructor(
        public enabled?: boolean,
        public fromPhoneNumber?: string,
        public apiKey?: string
    ) {
        this.enabled = enabled ? enabled : false;
        this.fromPhoneNumber = fromPhoneNumber ? fromPhoneNumber : '';
        this.apiKey = apiKey ? apiKey : null;
    }
}
